<template>
    <span class="icon-wrapper" :style="styleObject">
        <Icon :type="type" :color="color" :size="size" />
    </span>
</template>

<script>
import Icon from './Icon';

export default {
    name: 'IconRounded',
    components: { Icon },
    props: ['type', 'color', 'size', 'background', 'padding'],
    computed: {
        styleObject: function() {
            return {
                background: this.background || '#ffa306',
                padding: this.padding || '0.3em',
            };
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span {
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    line-height: 1;
}
</style>
